import React, { useEffect, useState } from "react";
import "../css/main.css";
import "../css/dashboard.css";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { apiRequest, API_BASE_URL } from "../api";

const MultiUserDashboard = () => {
    const [numbers, setNumbers] = useState([]);
    const [error, setError] = useState(null);
    const apiUrl = API_BASE_URL;

    const firstName = localStorage.getItem("firstName");
    const navigate = useNavigate();

    // Logout handler
    const handleLogout = (event) => {
        event.preventDefault();
        console.log("Navigating to /login...");
        localStorage.clear(); // Clear all stored session data
        navigate("/login");
    };

    // Fetch dashboard numbers
    useEffect(() => {
        const fetchMultiUserStats = async () => {
            try {
                const token = localStorage.getItem("token");
                
                // Get universities for this multi-user using fetch directly
                const universitiesResponse = await fetch(`${apiUrl}/multi-user-universities`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    }
                });
                
                if (!universitiesResponse.ok) {
                    throw new Error("Failed to fetch universities");
                }
                
                const universities = await universitiesResponse.json();
                
                // Calculate total stats across all universities
                let totalTours = 0;
                let totalEvents = 0;
                let totalSubmissions = 0;
                
                for (const university of universities || []) {
                    try {
                        const statsResponse = await fetch(`${apiUrl}/dashboard/${university.id}/numbers`, {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                "Authorization": `Bearer ${token}`
                            }
                        });
                        
                        if (statsResponse.ok) {
                            const stats = await statsResponse.json();
                            if (Array.isArray(stats) && stats.length >= 3) {
                                totalTours += stats[0] || 0;
                                totalEvents += stats[1] || 0;
                                totalSubmissions += stats[2] || 0;
                            }
                        }
                    } catch (error) {
                        console.error(`Error fetching stats for university ${university.id}:`, error);
                    }
                }
                
                setNumbers([totalTours, totalEvents, totalSubmissions]);
            } catch (error) {
                console.error("Error fetching multi-user stats:", error);
                setError("Failed to load statistics. Please try again.");
            }
        };

        fetchMultiUserStats();
    }, []);

    return (
        <div className="dashboard">
            <Sidebar/>

            <main className="main-content">
                <header className="header">
                    <h3>Welcome back, {firstName}!</h3>
                    <h4>Overview</h4>
                    <hr />
                    <div className="overview">
                        <div className="overview-item"><h2>{numbers[0] || 0}</h2><p>Tours</p></div>
                        <div className="overview-item"><h2>{numbers[1] || 0}</h2><p>Events</p></div>
                        <div className="overview-item"><h2>{numbers[2] || 0}</h2><p>Submissions</p></div>
                    </div>
                </header>

                <section className="quick-actions">
                    <h4>Quick Actions</h4>
                    <hr />
                    <div className="actions">
                        <a href="/multi-tours" className="action-button new-tour">
                            <i className="fa fa-map" aria-hidden="true"></i> Manage Tours
                        </a>
                        <a href="/multi-events" className="action-button new-event">
                            <i className="fa fa-calendar" aria-hidden="true"></i> Manage Events
                        </a>
                        <a href="/multi-forms" className="action-button new-form">
                            <i className="fa fa-sticky-note" aria-hidden="true"></i> Manage Forms
                        </a>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default MultiUserDashboard; 